export var SupportedIconNames;
(function (SupportedIconNames) {
    SupportedIconNames["RefreshIcon"] = "refresh-cw-hr";
    SupportedIconNames["CheckCircleIcon"] = "check-circle";
    SupportedIconNames["ExclamationCircleIcon"] = "alert-triangle";
    SupportedIconNames["ArrowsRightLeftIcon"] = "switch-horizontal";
})(SupportedIconNames || (SupportedIconNames = {}));
//# sourceMappingURL=types.js.map